export default __webpack_public_path__ + "assets/images/1940968c47a4787fa6d151abdbdb374c.jpg";